import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { googleRequest, googleError, startGoogleAuth } from '../../lib/directGoogle';
export { startGoogleAuth } from '../../lib/directGoogle';
export const SOCIAL_INTENT_KEY = 'trainnova:social_intent';

export default function SocialAuthButtons({ mode = 'auth', next = '/', disabled = false, label, compact = false }) {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let alive = true;
    googleRequest('/config', undefined, 'GET').then(r => { if (alive) setEnabled(r.google); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  // Reauthentication must preserve the already verified Google flow.
  if (!enabled || next === '/auth/continue') return null;
  return <button type="button" disabled={disabled || busy}
    className={`flex h-12 items-center justify-center gap-2 rounded-xl border border-[#747775] bg-white px-3 text-[15px] font-medium text-[#1f1f1f] hover:bg-[#f2f2f2] disabled:opacity-50 ${compact ? 'min-w-[120px] flex-1' : 'w-full'}`}
    onClick={async () => { setBusy(true); try { await startGoogleAuth({ mode, next }); } catch (e) { toast.error(googleError(e)); setBusy(false); } }}>
    <svg aria-hidden="true" viewBox="0 0 48 48" className="h-[18px] w-[18px] shrink-0">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6C44.4 38.02 46.98 31.86 46.98 24.55z" />
      <path fill="#FBBC05" d="M10.53 28.59A14.41 14.41 0 0 1 9.75 24c0-1.59.27-3.13.78-4.59l-7.98-6.19A23.87 23.87 0 0 0 0 24c0 3.87.93 7.53 2.56 10.78z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.91-5.8l-7.73-6c-2.15 1.45-4.92 2.3-8.18 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
    {busy ? 'Öppnar Google…'  : label || 'Fortsätt med Google'}
  </button>;
}
